import { Service, ServiceToC } from "../Axios/Service";
import qs from "qs";
import store from "../../store";
const PROFILE = {
  apply: "VUE_APP_APPLY_PREFIX",
};

function getType(apiType) {
  return process.env[PROFILE[apiType]];
}

class ApplyApi {
  constructor(ApiType) {
    this.ApiType = ApiType;
  }
  firstSendApproval(bid,step) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/applyBusiness/firstSendApproval?bid=${bid}&step=${step}`,
      method: "post",
    });
  }
  applyDetail(id) {
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/applyBusiness/applyDetail`,
      method: "post",
      data: qs.stringify({ bid: id }),
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
  }
  approvalProcess(data) {
    console.log(data);
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/applyBusiness/approvalProcess`,
      method: "post",
      data,
    });
  }

  urgeReviewHttp(data) {
    console.log(data);
    let apiType = getType(this.ApiType);
    return Service({
      url: `/${apiType}/api/applyBusiness/urgeReview`,
      method: "post",
      data,
    });
  }
}
export default ApplyApi;
